// Matches the debounce delay already used for ADAI's job-history search
// (src/adai/utils/constants.js::HISTORY_DEBOUNCE_MS) — kept as a separate
// constant here since this file is shared across modules outside adai/.
export const SEARCH_DEBOUNCE_MS = 300;
export const DEFAULT_PAGE_SIZE = 20;

export const DEFAULT_CONTACT_EMAIL = "innovation.labs@jadeglobal.com";


// Order the SOW Analysis detail modal's severity chart/dropdown group by
// (pages/sow-analysis/AnalysisDetailModal.jsx).
export const SEVERITY_ORDER = ["Critical", "High", "Medium", "Low", "Unknown"];

// Sorts the SOW Analysis Issues tab's table by severity
// (pages/sow-analysis/AnalysisDetailModal.jsx).
export const SEVERITY_RANK = { critical: 0, high: 1, medium: 2, low: 3 };

// Display labels for the SOW Analysis rule-coverage buckets, keyed by
// sowAnalysisHelpers.js's coverageBucket() return value
// (pages/sow-analysis/AnalysisDetailModal.jsx).
export const COVERAGE_LABELS = { covered: "Covered", partial: "Partial", missing: "Missing" };

// Chart colors for the SOW Analysis rule-coverage donut and issue-severity
// bar chart (pages/sow-analysis/AnalysisCharts.jsx).
export const COVERAGE_COLORS = { Covered: "#22c55e", Partial: "#f59e0b", Missing: "#ef4444" };
export const SEVERITY_COLORS = { Critical: "#b91c1c", High: "#ef4444", Medium: "#f97316", Low: "#22c55e", Unknown: "#9ca3af" };

// Mirrors DIMENSION_CATEGORIES in
// architecture_scaffold/domain/sow/aggregates/sow_analysis_aggregate.py --
// buckets a SOW Analysis rule's fine-grained `engine_dimension` string (e.g.
// "Pricing / Rate Card", "Legal / Confidentiality") into
// risk/compliance/commercial by the same substring keyword match the
// backend uses when it composes
// risk_rationale/compliance_rationale/commercial_rationale
// (pages/sow-analysis/sowAnalysisHelpers.js).
export const DIMENSION_KEYWORDS = {
  risk: ["risk", "liability", "indemnity", "warranty", "governance", "termination", "insurance"],
  compliance: ["compliance", "security", "privacy", "data", "ip", "audit", "legal"],
  commercial: ["commercial", "pricing", "payment", "billing", "rate", "sla", "budget"],
};

// Admin pages that aren't scoped to a single account/project — the topbar's
// Account/Project switcher pills are hidden on these (pages/Dashboard.jsx).
// "/admin/accounts" covers both the accounts list and its
// account/:accountId detail route.
export const SWITCHER_HIDDEN_PATH_PREFIXES = ["/users", "/roles", "/permissions", "/admin/accounts"];
